import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//router dom
import { Link } from "react-router-dom";
//tags
import MetaTags from "react-meta-tags";

function ExpoArea(props) {
  function redirectLink(link) {
    window.location = link;
  }

  useEffect(() => {
    document.getElementById("title-expoArea").focus();
    props.loadingUserOff();
  }, []);

  return (
    <section className="section-expo" id="section-mainStage">
      <MetaTags>
        <title>Digital Lovers Festival - Página Expo Área</title>
      </MetaTags>
      <a id="title-expoArea" className="title-home" tabIndex={12}>
        Página Expo Área
      </a>
      <div className="div-buttons">
        {/* <Link className="link-expo" to={"/home/centros"}>
          <button
            tabIndex={13}
            className="option-expo"
            title="Acesse a página Centers"
          >
            Centers
          </button>
        </Link> */}

        <button
          tabIndex={13}
          className="option-expo"
          title="Acesse a página GDN-e"
          onClick={() => redirectLink("/home/centros")}
        >
          GND-e
        </button>

        <button
          tabIndex={14}
          className="option-expo"
          title="Acesse a página Digital Technology Innovation"
          onClick={() => redirectLink("/home/digital-tecnologia")}
        >
          Digital Technology Innovation
        </button>

        <button
          tabIndex={15}
          className="option-expo"
          title="Acesse a página Diversidade e inclusão"
          onClick={() => redirectLink("/home/diversidade")}
        >
          Diversidade e inclusão
        </button>

        <button
          tabIndex={16}
          className="option-expo"
          title="Acesse a página E S G"
          onClick={() => redirectLink("/home/esg")}
        >
          E S G
        </button>

        <button
          tabIndex={17}
          className="option-expo"
          title="Acesse a página People & Staffing"
          onClick={() => redirectLink("/home/pessoas")}
        >
          People & Staffing
        </button>

        <button
          tabIndex={18}
          className="option-expo"
          title="Acesse a página NTT Data Foundation"
          onClick={() => redirectLink("/home/ntt-fundacao")}
        >
          NTT Data Foundation
        </button>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpoArea);
